import MuiAlert from '@mui/material/Alert'
import {Typography, Box} from '@mui/material'
import {styled} from '@mui/material/styles'
import {FILTERS_DRAWER_WIDTH} from '../FilterPanel/FilterPanelStyle'

export const StyledFAQNoteBox = styled(Box)(({theme}) => ({
  width: '100%',
  marginTop: theme.spacing(2)
}))

export const StyledFAQNoteAlert = styled(MuiAlert)(({theme}) => ({
  backgroundColor: theme.palette.warning.light,
  color: theme.palette.text.primary,
  borderRadius: 0,
  alignItems: 'center',
  boxShadow: 'none',
  padding: 0,
  margin: 0,
  border: 'none',
  width: '100%',
  '& .MuiAlert-icon': {
    marginLeft: theme.spacing(2)
  }
}))

export const FAQStyledTypography = styled(Typography, {shouldForwardProp: (prop) => prop !== 'title'})(
  ({theme, title}) => ({
    textAlign: 'left',
    fontSize: title ? theme.typography.h5.fontSize : theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: title ? theme.typography.listItemSmall.lineHeight : theme.typography.subtitle1.lineHeight,
    color: theme.palette.hpAccentBlack,
    letterSpacing: title ? '' : '0.25px'
  })
)

export const FAQStyledBox = styled(Box)(({theme}) => ({
  boxShadow: '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
  width: 'auto',
  borderRadius: '4px',
  background: theme.palette.hpWhite,
  padding: '32px',
  overflow: 'auto',
  height: '90vh'
}))

export const FAQMainBox = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'column',
  maxWidth: 'calc(100vw - 64px)',
  marginLeft: `-${FILTERS_DRAWER_WIDTH}px`,
  backgroundColor: 'background.default',
  padding: '16px',
  marginTop: '40px'
}))
